const catalogConfig = {
    ip: process.env.ACKO_DRIVE_CATALOG_SERVICE,
    internal_ip: process.env.ACKO_DRIVE_CATALOG_SERVICE_INTERNAL,
};

export default catalogConfig;